export const dateFormation = timework => {
  if (typeof timework !== 'string') {
    return '';
  }

  const listDate = timework.split('<br>');
  if (listDate.length === 1) {
    return timework;
  } else {
    const dayWeek = new Date().getDay();
    switch (dayWeek) {
      case 0:
        return 'c ' + listDate[2]?.slice(listDate[2]?.length - 11).replace('–', ' до ');
      case 6:
        return 'c ' + listDate[1]?.slice(listDate[1]?.length - 11).replace('–', ' до ');
      default:
        return 'c ' + listDate[0]?.slice(listDate[0]?.length - 11).replace('–', ' до ');
    }
  }
};

export const formatPhone = (str: string) => {
  if (typeof str !== 'string') {
    return '';
  }
  const phoneReg = /(?:\+|\d)[\d\-(\\) ]{9,}\d/g;

  return str.match(phoneReg);
};
